var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.677,
    height: 22.666,
    viewBox: "0 0 25.677 22.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M39.418,25.158v5.706H19.447V25.158H16.594v8.559H42.271V25.158Z",
    transform: "translate(-16.594 -11.051)",
    fill: "#307ad7",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M30.077,10.806V22.34H32.93V10.806l4.243,4.244,2.018-2.018L31.539,5.38h0l-7.723,7.652,2.018,2.018Z",
    transform: "translate(-18.665 -5.38)",
    fill: "#307ad7",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.fcb25349dcfacf8cdf6dcd569eab8a92.svg";
export { ForwardRef as ReactComponent };